import { useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import Adesao from "./Engajamento/Adesao";
import Acesso from "./Engajamento/Acesso";
import AlunoResponsavelAtivo from "./AlunoResponsavel/AlunoResponsavelAtivo";
import MuralUsuarioContainer from "./Mural/MuralUsuario/MuralUsuarioContainer";
import TarefaContainer from "./Tarefa/TarefaContainer";
import { currentUser } from "./Usuario/api-usuario";
import { setUsuario } from "./Usuario/actions/actions";
import { ADMIN, COORDENADOR, perfilText, PROFESSOR, RESPONSAVEL, SECRETARIA } from "./Usuario/Perfil";
import { errorMessage } from "../util/ConfirmAlertUtil";
import { splitUtil } from "../util/StringUtil";

const PERFIS_EQUIPE = [ADMIN, COORDENADOR, SECRETARIA, PROFESSOR];

const saudacao = () => {
  const hora = new Date().getHours();
  if (hora < 12) return "Bom dia";
  if (hora < 18) return "Boa tarde";
  return "Boa noite";
};

const SectionTitle = ({ children }) => (
  <Typography variant="overline" color="text.secondary" component="h2" display="block" mb={1}>
    {children}
  </Typography>
);

export default function Home() {
  const usuario = useSelector((state) => state.usuario);
  const dispatch = useDispatch();

  // Atualiza os dados do usuário (perfil, instituição, aluno selecionado) ao entrar.
  useEffect(() => {
    currentUser().then((data) => {
      if (!data) return;
      if (data.error) {
        errorMessage(data.message);
        return;
      }
      dispatch(setUsuario(data));
      if (data.instituicao?.descricao) {
        document.title = data.instituicao.descricao;
      }
    });
  }, [dispatch]);

  const isEquipe = PERFIS_EQUIPE.includes(usuario?.perfil);
  const isResponsavel = usuario?.perfil === RESPONSAVEL;

  return (
    <Stack spacing={3}>
      <Paper variant="outlined" sx={{ borderRadius: 2, p: { xs: 2, sm: 3 } }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar
            src={usuario?.fileName ? usuario.fotoUrl : undefined}
            alt={usuario?.nome}
            sx={{ width: 56, height: 56 }}
          />
          <Box minWidth={0}>
            <Typography variant="h6" noWrap>
              {saudacao()}
              {usuario?.nome ? `, ${splitUtil(usuario.nome, " ", 2)}` : ""}!
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
              {usuario?.perfil && <Chip size="small" label={perfilText(usuario.perfil)} />}
              {usuario?.instituicao?.descricao && (
                <Typography variant="body2" color="text.secondary">
                  {usuario.instituicao.descricao}
                </Typography>
              )}
            </Stack>
          </Box>
        </Stack>
      </Paper>

      {isEquipe && (
        <>
          <Box>
            <SectionTitle>Tarefas</SectionTitle>
            <TarefaContainer />
          </Box>
          <Box>
            <SectionTitle>Engajamento</SectionTitle>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, lg: 6 }}>
                <Adesao />
              </Grid>
              <Grid size={{ xs: 12, lg: 6 }}>
                <Acesso />
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {isResponsavel && (
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <MuralUsuarioContainer />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <AlunoResponsavelAtivo />
          </Grid>
        </Grid>
      )}
    </Stack>
  );
}
